// extracted by mini-css-extract-plugin
export var chevron = "_jq-2";
export var dropdownItems = "_jq-0";
export var item = "_jq-1";